import React from 'react'
import PropTypes from 'prop-types'

import { Flex } from 'Components/UI/_Legacy'

import { SubTitleText } from './styles'

function HeadingSubTitle({
  horizontalAlign = 'center',
  subTitleText,
  fontSize,
  dark = false,
}) {
  return (
    <Flex
      maxWidth={horizontalAlign === 'center' ? '80%' : '95%'}
      pt={6}
      textAlign={horizontalAlign}
    >
      <SubTitleText
        center={horizontalAlign === 'center'}
        dark={dark}
        fontSize={fontSize}
      >
        {subTitleText}
      </SubTitleText>
    </Flex>
  )
}

HeadingSubTitle.propTypes = {
  dark: PropTypes.bool,
  fontSize: PropTypes.array.isRequired,
  horizontalAlign: PropTypes.string,
  subTitleText: PropTypes.string.isRequired,
}

export default HeadingSubTitle
